import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class FlyToCartService {
  public animatedSubject = new Subject<{id: string, source: string}>()

  animateFlyToCart(id, source) {
    this.animatedSubject.next({id, source})
  }
}
